module.exports = __webpack_public_path__ + "i18n/zh-CN.9544d9c14c2116e6580fc992a97acc3a.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/zh-CN.json
// module id = 1012
// module chunks = 60